// ============================================
// CHATBOT WIDGET POUR SHOPIFY - v2
// Fix: mobile keyboard, viewport, scroll
// ============================================

(function() {
    'use strict';

    // Configuration du chatbot
    const CHATBOT_CONFIG = {
        webhookUrl: 'https://n8n.srv1261952.hstgr.cloud/webhook/2df9ea18-02cc-402d-868b-7db7271a36cb/chat',
        enabled: true,
        simulateMode: false,
        requestFormat: 'n8n-chat',
        avatarUrl: (window.CHATBOT_CONFIG && window.CHATBOT_CONFIG.avatarUrl) || 'Photos/milou-avatar.webp.png'
    };

    // Session n8n
    let chatSessionId = null;

    // Elements DOM
    let chatbotToggle = null;
    let chatbotWindow = null;
    let chatbotClose = null;
    let chatbotInput = null;
    let chatbotSend = null;
    let chatbotMessages = null;
    let chatbotBadge = null;

    // Etat
    let unreadCount = 0;
    let isOpen = false;
    let notificationShown = false;
    let isMobile = false;
    let keyboardVisible = false;

    // Detecter mobile une seule fois, et mettre a jour au resize
    function checkMobile() {
        isMobile = window.innerWidth <= 480 ||
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        return isMobile;
    }

    // ---- INITIALISATION ----
    function initChatbot() {
        if (!CHATBOT_CONFIG.enabled) {
            const container = document.getElementById('chatbot-container');
            if (container) {
                container.style.display = 'none';
                container.style.visibility = 'hidden';
            }
            return;
        }

        document.body.classList.add('chatbot-enabled');

        chatbotToggle = document.getElementById('chatbot-toggle');
        chatbotWindow = document.getElementById('chatbot-window');
        chatbotClose = document.getElementById('chatbot-close');
        chatbotInput = document.getElementById('chatbot-input');
        chatbotSend = document.getElementById('chatbot-send');
        chatbotMessages = document.getElementById('chatbot-messages');
        chatbotBadge = document.getElementById('chatbot-badge');

        if (!chatbotToggle || !chatbotWindow) {
            console.warn('Chatbot: Elements DOM non trouves.');
            return;
        }

        checkMobile();
        setupEventListeners();
    }

    // ---- EVENT LISTENERS ----
    function setupEventListeners() {
        // Toggle open/close
        if (chatbotToggle) {
            chatbotToggle.addEventListener('click', function() {
                toggleChatbot();
                stopNotificationAnimation();
            });
        }

        if (chatbotClose) {
            chatbotClose.addEventListener('click', function() {
                closeChatbot();
            });
        }

        // Envoyer message
        if (chatbotSend) {
            chatbotSend.addEventListener('click', sendMessage);
        }

        if (chatbotInput) {
            chatbotInput.addEventListener('keypress', function(e) {
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                }
            });

            // Gestion clavier mobile - approche simplifiee
            chatbotInput.addEventListener('focus', onInputFocus);
            chatbotInput.addEventListener('blur', onInputBlur);
        }

        // VisualViewport API - seule source de verite pour le clavier mobile
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', onViewportResize);
        }

        // Detecter changement d'orientation / taille
        window.addEventListener('resize', function() {
            checkMobile();
        });
    }

    // ---- GESTION CLAVIER MOBILE ----
    function onInputFocus() {
        if (!isMobile || !chatbotWindow || !isOpen) return;

        // Attendre que le clavier s'ouvre
        setTimeout(function() {
            if (document.activeElement === chatbotInput) {
                keyboardVisible = true;
                updateViewportHeight();
                chatbotWindow.classList.add('keyboard-open');
                scrollToBottom();
            }
        }, 300);
    }

    function onInputBlur() {
        if (!isMobile || !chatbotWindow) return;

        setTimeout(function() {
            if (document.activeElement !== chatbotInput) {
                keyboardVisible = false;
                chatbotWindow.classList.remove('keyboard-open');
            }
        }, 150);
    }

    function onViewportResize() {
        if (!isMobile || !chatbotWindow || !isOpen) return;

        if (document.activeElement === chatbotInput) {
            // Clavier ouvert: mettre a jour la hauteur CSS
            keyboardVisible = true;
            updateViewportHeight();
            chatbotWindow.classList.add('keyboard-open');
            scrollToBottom();
        } else {
            if (keyboardVisible) {
                keyboardVisible = false;
                chatbotWindow.classList.remove('keyboard-open');
            }
        }
    }

    // Envoyer la hauteur visible reelle au CSS via custom property
    function updateViewportHeight() {
        var vpHeight;
        if (window.visualViewport) {
            vpHeight = window.visualViewport.height;
        } else {
            vpHeight = window.innerHeight;
        }
        // Injecter la hauteur sur le chatbot-window directement
        if (chatbotWindow) {
            chatbotWindow.style.setProperty('--chatbot-vp-height', vpHeight + 'px');
        }
    }

    // ---- TOGGLE / OPEN / CLOSE ----
    function toggleChatbot() {
        if (isOpen) {
            closeChatbot();
        } else {
            openChatbot();
        }
    }

    function openChatbot() {
        if (!chatbotWindow) return;
        chatbotWindow.classList.add('open');
        isOpen = true;
        unreadCount = 0;
        updateBadge();
        stopNotificationAnimation();

        // Focus sur l'input apres l'animation
        setTimeout(function() {
            // Sur mobile, ne pas auto-focus pour eviter l'ouverture immediate du clavier
            if (!isMobile && chatbotInput) {
                chatbotInput.focus();
            }
        }, 100);
    }

    function closeChatbot() {
        if (!chatbotWindow) return;

        // D'abord enlever le mode clavier si actif
        keyboardVisible = false;
        chatbotWindow.classList.remove('keyboard-open');

        // Blur l'input pour fermer le clavier
        if (chatbotInput) {
            chatbotInput.blur();
        }

        chatbotWindow.classList.remove('open');
        isOpen = false;
    }

    // ---- ENVOI DE MESSAGE ----
    async function sendMessage() {
        const message = chatbotInput?.value.trim();
        if (!message || !chatbotSend) return;

        chatbotSend.disabled = true;
        addMessage(message, 'user');
        if (chatbotInput) chatbotInput.value = '';

        const loadingElement = addLoadingMessage();

        try {
            let botResponse;

            if (CHATBOT_CONFIG.webhookUrl && !CHATBOT_CONFIG.simulateMode) {
                let requestBody;
                let headers = { 'Content-Type': 'application/json' };

                if (CHATBOT_CONFIG.requestFormat === 'n8n-chat') {
                    if (!chatSessionId) {
                        chatSessionId = 'session-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
                    }
                    requestBody = JSON.stringify({
                        action: 'sendMessage',
                        sessionId: chatSessionId,
                        chatInput: message
                    });
                } else if (CHATBOT_CONFIG.requestFormat === 'simple') {
                    requestBody = JSON.stringify({ message: message });
                } else {
                    requestBody = JSON.stringify({
                        message: message,
                        timestamp: new Date().toISOString()
                    });
                }

                const response = await fetch(CHATBOT_CONFIG.webhookUrl, {
                    method: 'POST',
                    headers: headers,
                    body: requestBody
                });

                if (!response.ok) {
                    let errorDetails = '';
                    try {
                        const errorData = await response.json();
                        errorDetails = errorData.message || errorData.error || JSON.stringify(errorData);
                    } catch (e) {
                        errorDetails = await response.text() || 'Erreur inconnue';
                    }

                    const errorMessage = response.status === 500
                        ? 'Erreur du serveur n8n: ' + errorDetails + '. Verifiez la configuration du workflow.'
                        : 'Erreur HTTP ' + response.status + ': ' + errorDetails;

                    throw new Error(errorMessage);
                }

                const contentType = response.headers.get('content-type');
                let data;

                if (contentType && contentType.includes('application/json')) {
                    data = await response.json();
                } else {
                    const textResponse = await response.text();
                    try {
                        data = JSON.parse(textResponse);
                    } catch (e) {
                        data = textResponse;
                    }
                }

                // Extraire sessionId
                if (data && typeof data === 'object') {
                    const jsonData = data.json || data;
                    if (jsonData.sessionId && !chatSessionId) {
                        chatSessionId = jsonData.sessionId;
                    }
                }

                // Extraire la reponse
                if (typeof data === 'string') {
                    botResponse = data;
                } else if (Array.isArray(data) && data.length > 0) {
                    const firstItem = data[0];
                    const jsonData = firstItem.json || firstItem;
                    botResponse = jsonData.output || jsonData.response || jsonData.message ||
                                 jsonData.text || jsonData.reply ||
                                 (typeof firstItem === 'string' ? firstItem : JSON.stringify(firstItem));
                } else if (data && typeof data === 'object') {
                    if (data.firstEntryJson) {
                        const entryData = typeof data.firstEntryJson === 'string'
                            ? JSON.parse(data.firstEntryJson)
                            : data.firstEntryJson;
                        const jsonData = entryData.json || entryData;
                        botResponse = jsonData.output || jsonData.response || jsonData.message ||
                                     jsonData.text || jsonData.reply || JSON.stringify(entryData);
                    } else {
                        const jsonData = data.json || data;
                        botResponse = jsonData.output || jsonData.response || jsonData.message ||
                                     jsonData.text || jsonData.reply ||
                                     data.output || data.response || data.message || data.text || data.reply ||
                                     data.data?.output || data.data?.response || data.data?.message ||
                                     data.body?.output || data.body?.response || data.body?.message ||
                                     'Desole, je n\'ai pas pu traiter votre demande.';
                    }
                } else {
                    botResponse = 'Desole, je n\'ai pas pu traiter votre demande.';
                }
            } else {
                botResponse = getSimulatedResponse(message);
                await new Promise(function(resolve) { setTimeout(resolve, 800); });
            }

            removeMessage(loadingElement);
            addMessage(botResponse, 'bot');

            if (!isOpen) {
                unreadCount++;
                updateBadge();
            }
        } catch (error) {
            removeMessage(loadingElement);
            console.error('Erreur chatbot:', error);

            let errorMessage;
            if (error.message.includes('500') || error.message.includes('Erreur du serveur n8n')) {
                errorMessage = 'Desole, le service de chat est temporairement indisponible. Veuillez reessayer plus tard.';
            } else if (error.message.includes('CORS') || error.message.includes('Failed to fetch')) {
                errorMessage = 'Impossible de se connecter au service de chat. Verifiez votre connexion internet.';
            } else {
                errorMessage = CHATBOT_CONFIG.webhookUrl
                    ? 'Desole, une erreur est survenue. Veuillez reessayer plus tard.'
                    : 'Le chatbot est en cours de configuration. Veuillez patienter.';
            }
            addMessage(errorMessage, 'bot');
        } finally {
            if (chatbotSend) chatbotSend.disabled = false;
        }
    }

    // ---- REPONSES SIMULEES ----
    function getSimulatedResponse(message) {
        const lower = message.toLowerCase();

        if (lower.includes('bonjour') || lower.includes('salut') || lower.includes('hello')) {
            return 'Bonjour ! Comment puis-je vous aider aujourd\'hui ?';
        }
        if (lower.includes('prix') || lower.includes('cout') || lower.includes('tarif')) {
            return 'Vous pouvez consulter nos prix directement sur la page des produits. N\'hesitez pas a me dire si vous avez des questions specifiques !';
        }
        if (lower.includes('livraison') || lower.includes('expedition')) {
            return 'Nous offrons la livraison gratuite pour les commandes de 60$ et plus !';
        }
        if (lower.includes('commande') || lower.includes('acheter') || lower.includes('panier')) {
            return 'Vous pouvez ajouter des produits a votre panier directement depuis la page boutique. Besoin d\'aide pour autre chose ?';
        }
        if (lower.includes('merci') || lower.includes('remercie')) {
            return 'De rien ! N\'hesitez pas si vous avez d\'autres questions.';
        }

        return 'Merci pour votre message ! Le chatbot est en cours de configuration.';
    }

    // ---- LINKIFY ----
    function linkify(text) {
        var emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
        var httpPattern = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+)/gi;
        var wwwPattern = /(www\.[^\s<>"{}|\\^`\[\]]+)/gi;

        var result = text;

        result = result.replace(emailPattern, function(match) {
            var clean = match.replace(/[.,;:!?)\]}]+$/, '');
            return '<a href="mailto:' + clean + '">' + clean + '</a>';
        });

        result = result.replace(httpPattern, function(match) {
            if (match.includes('</a>') || match.includes('<a')) return match;
            var clean = match.replace(/[.,;:!?)\]}]+$/, '');
            return '<a href="' + clean + '" target="_blank" rel="noopener noreferrer">' + clean + '</a>';
        });

        result = result.replace(wwwPattern, function(match) {
            if (match.includes('</a>') || match.includes('<a')) return match;
            var clean = match.replace(/[.,;:!?)\]}]+$/, '');
            return '<a href="https://' + clean + '" target="_blank" rel="noopener noreferrer">' + clean + '</a>';
        });

        return result;
    }

    // ---- AJOUTER UN MESSAGE ----
    function addMessage(text, type) {
        if (!chatbotMessages) return null;

        var messageDiv = document.createElement('div');
        messageDiv.className = 'message ' + type;

        if (type === 'bot') {
            var avatarImg = document.createElement('img');
            avatarImg.src = CHATBOT_CONFIG.avatarUrl;
            avatarImg.alt = 'Mylou';
            avatarImg.className = 'message-avatar';
            avatarImg.onerror = function() { this.style.display = 'none'; };
            messageDiv.appendChild(avatarImg);
        }

        var wrapperDiv = document.createElement('div');
        wrapperDiv.className = 'message-wrapper';

        var contentDiv = document.createElement('div');
        contentDiv.className = 'message-content';

        var textP = document.createElement('p');
        var processed = linkify(text);
        processed = processed.replace(/\n/g, '<br>');
        textP.innerHTML = processed;
        contentDiv.appendChild(textP);

        var timeDiv = document.createElement('div');
        timeDiv.className = 'message-time';
        timeDiv.textContent = getCurrentTime();

        wrapperDiv.appendChild(contentDiv);
        wrapperDiv.appendChild(timeDiv);
        messageDiv.appendChild(wrapperDiv);
        chatbotMessages.appendChild(messageDiv);
        scrollToBottom();

        return messageDiv;
    }

    // ---- LOADING MESSAGE ----
    function addLoadingMessage() {
        if (!chatbotMessages) return null;

        var messageDiv = document.createElement('div');
        messageDiv.className = 'message bot loading';

        var avatarImg = document.createElement('img');
        avatarImg.src = CHATBOT_CONFIG.avatarUrl;
        avatarImg.alt = 'Mylou';
        avatarImg.className = 'message-avatar';
        avatarImg.onerror = function() { this.style.display = 'none'; };
        messageDiv.appendChild(avatarImg);

        var wrapperDiv = document.createElement('div');
        wrapperDiv.className = 'message-wrapper';

        var contentDiv = document.createElement('div');
        contentDiv.className = 'message-content';

        for (var i = 0; i < 3; i++) {
            contentDiv.appendChild(document.createElement('span'));
        }

        wrapperDiv.appendChild(contentDiv);
        messageDiv.appendChild(wrapperDiv);
        chatbotMessages.appendChild(messageDiv);
        scrollToBottom();

        return messageDiv;
    }

    function removeMessage(el) {
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }

    function getCurrentTime() {
        return new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    }

    function scrollToBottom() {
        if (chatbotMessages) {
            // requestAnimationFrame pour s'assurer que le DOM est mis a jour
            requestAnimationFrame(function() {
                chatbotMessages.scrollTop = chatbotMessages.scrollHeight;
            });
        }
    }

    // ---- BADGE ----
    function updateBadge() {
        if (!chatbotBadge) return;
        if (unreadCount > 0) {
            chatbotBadge.textContent = unreadCount > 9 ? '9+' : unreadCount.toString();
            chatbotBadge.classList.add('active');
        } else {
            chatbotBadge.classList.remove('active');
        }
    }

    // ---- NOTIFICATION ANIMATION ----
    function startNotificationAnimation() {
        if (notificationShown || isOpen) return;

        var pulse = document.getElementById('chatbot-notification-pulse');
        if (pulse && chatbotToggle) {
            pulse.classList.add('active');
            chatbotToggle.classList.add('notification-pulse');
            notificationShown = true;
        }
    }

    function stopNotificationAnimation() {
        var pulse = document.getElementById('chatbot-notification-pulse');
        if (pulse) pulse.classList.remove('active');
        if (chatbotToggle) chatbotToggle.classList.remove('notification-pulse');
        notificationShown = false;
    }

    // ---- DEMARRAGE ----
    // Notification apres 5 secondes
    setTimeout(function() {
        if (!isOpen) startNotificationAnimation();
    }, 5000);

    // Avatar URL
    if (window.CHATBOT_CONFIG && window.CHATBOT_CONFIG.avatarUrl) {
        CHATBOT_CONFIG.avatarUrl = window.CHATBOT_CONFIG.avatarUrl;
    }

    // Init
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            if (window.CHATBOT_CONFIG && window.CHATBOT_CONFIG.avatarUrl) {
                CHATBOT_CONFIG.avatarUrl = window.CHATBOT_CONFIG.avatarUrl;
            }
            initChatbot();
        });
    } else {
        initChatbot();
    }

})();
